import React, { Component } from 'react'
import store from 'store'
import { Alert } from '../../components/Alerta'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

class ModalCertificado extends Component {
    constructor(props) {
        super(props);
        this.state = {
            show: false,
            empresa: null,
            certificadoActual: null,
            isLoading: false,
            isSaving: false,
            archivoBase64: '',
            nombreArchivo: '',
            contrasenia: '',
            mostrarClave: false,
            mensajeError: '',
            mensajeExito: ''
        };
    }

    open = (empresa) => {
        this.setState({
            show: true,
            empresa: empresa,
            certificadoActual: null,
            isLoading: true,
            isSaving: false,
            archivoBase64: '',
            nombreArchivo: '',
            contrasenia: '',
            mostrarClave: false,
            mensajeError: '',
            mensajeExito: ''
        }, () => {
            document.body.classList.add('modal-open');
            this.consultarCertificadoActual(empresa.empresa_id);
        });
    }

    close = () => {
        this.setState({ show: false }, () => {
            document.body.classList.remove('modal-open');
        });
    }

    consultarCertificadoActual = (empresaId) => {
        fetch(`${this.props.server}dashboardsa/empresa/certificado/consultar?empresa_id=${empresaId}`, {
            method: 'GET',
            headers: new Headers({
                'AuthorizationSa': store.get('data').token,
                'email': store.get('data').usuario.email,
                'pin': store.get('data').pin,
            })
        })
        .then(res => res.json())
        .then(data => {
            this.setState({
                isLoading: false,
                certificadoActual: (data.status === 200 && data.existe) ? data.datos : null
            });
        })
        .catch(err => {
            console.error(err);
            this.setState({ isLoading: false });
        });
    }

    handleFileChange = (e) => {
        const file = e.target.files[0];
        if (!file) return;

        if (!file.name.toLowerCase().endsWith('.pfx') && !file.name.toLowerCase().endsWith('.p12')) {
            this.setState({ mensajeError: 'Por favor selecciona un archivo con extensión .pfx o .p12' });
            return;
        }

        const reader = new FileReader();
        reader.onload = (uploadEvent) => {
            this.setState({
                archivoBase64: uploadEvent.target.result,
                nombreArchivo: file.name,
                mensajeError: ''
            });
        };
        reader.onerror = () => {
            this.setState({ mensajeError: 'Error al leer el archivo seleccionado' });
        };
        reader.readAsDataURL(file);
    }

    handleSubmit = (e) => {
        e.preventDefault();
        const { empresa, archivoBase64, nombreArchivo, contrasenia } = this.state;

        if (!archivoBase64) {
            this.setState({ mensajeError: 'Debes seleccionar un archivo de certificado (.pfx o .p12)' });
            return;
        }
        if (!contrasenia || contrasenia.trim() === '') {
            this.setState({ mensajeError: 'Debes ingresar la contraseña del certificado' });
            return;
        }

        this.setState({ isSaving: true, mensajeError: '', mensajeExito: '' });

        const authData = store.get('data') || {};
        const usuario = authData.usuario || {};

        const payload = {
            empresa_id: empresa.empresa_id,
            usuario_id: usuario.id || usuario.usuario_id || null,
            nombre_archivo: nombreArchivo || 'Certificado.pfx',
            archivo_pfx_base64: archivoBase64,
            contrasenia: contrasenia
        };

        fetch(`${this.props.server}dashboardsa/empresa/certificado/guardar`, {
            method: 'POST',
            headers: new Headers({
                'AuthorizationSa': store.get('data').token,
                'email': store.get('data').usuario.email,
                'pin': store.get('data').pin,
                'Content-Type': 'application/json'
            }),
            body: JSON.stringify(payload)
        })
        .then(res => res.json())
        .then(data => {
            this.setState({ isSaving: false });
            if (data.status === 200) {
                let msg = data.mensaje || 'Certificado guardado exitosamente.';
                if (data.nit && data.nit_empresa && data.nit_coincide === false) {
                    msg += ` (Advertencia: NIT certificado [${data.nit}] difiere del NIT registrado [${data.nit_empresa}])`;
                }
                this.setState({
                    mensajeExito: msg,
                    archivoBase64: '',
                    contrasenia: ''
                });
                Alert('success', 'Certificado Actualizado', 'El certificado fue validado criptográficamente y cargado correctamente.');
                this.consultarCertificadoActual(empresa.empresa_id);
                if (this.props.onSuccess) {
                    this.props.onSuccess();
                }
            } else {
                this.setState({ mensajeError: data.mensaje || 'Error al validar o guardar el certificado.' });
                Alert('danger', 'Error al Guardar', data.mensaje || 'Error desconocido');
            }
        })
        .catch(err => {
            console.error(err);
            this.setState({ isSaving: false, mensajeError: 'Error de conexión con el servidor.' });
            Alert('danger', 'Error', 'No se pudo contactar al servidor.');
        });
    }

    toggleMostrarClave = () => {
        this.setState(prev => ({ mostrarClave: !prev.mostrarClave }));
    }

    renderNitBadge = (nitCert, nitEmpresa) => {
        if (!nitCert || !nitEmpresa) return null;
        const cleanCert = String(nitCert).replace(/\D/g, '');
        const cleanEmp = String(nitEmpresa).replace(/\D/g, '');
        if (!cleanCert || !cleanEmp) return null;

        const coincide = cleanCert === cleanEmp || cleanCert.startsWith(cleanEmp) || cleanEmp.startsWith(cleanCert);
        if (coincide) {
            return (
                <span className="badge badge-success ml-2 py-1 px-2" title="El NIT coincide con la empresa">
                    ✓ Coincide con empresa
                </span>
            );
        } else {
            return (
                <span className="badge badge-warning text-dark ml-2 py-1 px-2" title={`Difiere del NIT de la empresa (${nitEmpresa})`}>
                    ⚠️ Difiere del NIT (${nitEmpresa})
                </span>
            );
        }
    }

    render() {
        const { show, empresa, certificadoActual, isLoading, isSaving, nombreArchivo, contrasenia, mostrarClave, mensajeError, mensajeExito } = this.state;
        if (!show) return null;

        const nitEmpresaRef = (empresa && (empresa.nit_empresa || empresa.nit)) || (certificadoActual && certificadoActual.nit_empresa);

        return (
            <div className="modal fade show" tabIndex="-1" role="dialog" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}>
                <div className="modal-dialog modal-lg" role="document">
                    <div className="modal-content text-left">
                        <div className="modal-header bg-primary text-white py-2">
                            <h5 className="modal-title font-weight-bold">
                                <FontAwesomeIcon icon="key" className="mr-2" />
                                Gestión de Certificado DIAN - {empresa ? empresa.nombre_negocio : ''}
                            </h5>
                            <button type="button" className="close text-white" onClick={this.close} aria-label="Cerrar">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body p-4">
                            {/* Información actual reportada */}
                            <div className="card mb-3 shadow-sm border-0 bg-light">
                                <div className="card-body py-3">
                                    <h6 className="card-title text-muted text-uppercase font-weight-bold mb-2" style={{ fontSize: '0.8rem' }}>
                                        Estado Actual en Emisor / Central
                                    </h6>
                                    <div className="row">
                                        <div className="col-md-5 mb-2 border-right">
                                            <span className="text-secondary d-block small">Vencimiento reportado por el emisor:</span>
                                            {(() => {
                                                const dias = empresa && empresa.dias_vence_certificado != null && empresa.dias_vence_certificado !== '' ? Number(empresa.dias_vence_certificado) : null;
                                                const esCritico = dias !== null && !isNaN(dias) && dias < 30;
                                                return (
                                                    <strong className={esCritico ? "text-danger" : ""} style={esCritico ? { color: '#dc3545' } : {}}>
                                                        {empresa && empresa.vence_certificado ? empresa.vence_certificado : 'No reportado'}
                                                        {esCritico && (
                                                            <span className="ml-1 small">({dias <= 0 ? 'Vencido' : `${Math.round(dias)}d`})</span>
                                                        )}
                                                    </strong>
                                                );
                                            })()}
                                            {nitEmpresaRef && (
                                                <div className="small text-muted mt-2">
                                                    NIT Registrado: <strong>{nitEmpresaRef}</strong>
                                                </div>
                                            )}
                                        </div>
                                        <div className="col-md-7 mb-2">
                                            <span className="text-secondary d-block small mb-1">Estado en Servidor Central:</span>
                                            {isLoading ? (
                                                <span className="text-muted small">
                                                    <span className="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
                                                    Cargando estado...
                                                </span>
                                            ) : certificadoActual ? (
                                                <div>
                                                    <div className="mb-2">
                                                        {certificadoActual.pendiente_entrega ? (
                                                            <span className="badge badge-warning text-dark p-2 font-weight-bold">
                                                                ⏳ Pendiente de sincronizar con el facturador
                                                            </span>
                                                        ) : (
                                                            <span className="badge badge-success p-2 font-weight-bold">
                                                                ✓ Sincronizado y entregado ({certificadoActual.fecha_entrega || 'Reciente'})
                                                            </span>
                                                        )}
                                                    </div>
                                                    <div className="bg-white rounded border p-2 small shadow-sm">
                                                        <div className="row no-gutters py-1 border-bottom">
                                                            <div className="col-4 text-secondary font-weight-bold">NIT Certificado:</div>
                                                            <div className="col-8">
                                                                <strong>{certificadoActual.nit || 'No extraído'}</strong>
                                                                {this.renderNitBadge(certificadoActual.nit, nitEmpresaRef)}
                                                            </div>
                                                        </div>
                                                        <div className="row no-gutters py-1 border-bottom">
                                                            <div className="col-4 text-secondary font-weight-bold">Titular / Razón:</div>
                                                            <div className="col-8">
                                                                <strong>{certificadoActual.titular || 'No especificado'}</strong>
                                                            </div>
                                                        </div>
                                                        <div className="row no-gutters py-1 border-bottom">
                                                            <div className="col-4 text-secondary font-weight-bold">Entidad Emisora:</div>
                                                            <div className="col-8 text-truncate" title={certificadoActual.emisor}>
                                                                <span>{certificadoActual.emisor || 'No especificada'}</span>
                                                            </div>
                                                        </div>
                                                        <div className="row no-gutters py-1 border-bottom">
                                                            <div className="col-4 text-secondary font-weight-bold">Alias y Vence:</div>
                                                            <div className="col-8">
                                                                <code>{certificadoActual.alias || 'N/A'}</code> &bull; Vence: <strong>{certificadoActual.fecha_vence || 'N/A'}</strong>
                                                            </div>
                                                        </div>
                                                        {certificadoActual.usuario_nombre && (
                                                            <div className="row no-gutters py-1">
                                                                <div className="col-4 text-secondary font-weight-bold">Cargado por:</div>
                                                                <div className="col-8 text-muted">
                                                                    {certificadoActual.usuario_nombre} ({certificadoActual.fecha_carga || ''})
                                                                </div>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            ) : (
                                                <span className="badge badge-secondary p-2">Sin certificado cargado en central</span>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Alertas */}
                            {mensajeError && (
                                <div className="alert alert-danger alert-dismissible fade show" role="alert">
                                    <strong>Error: </strong> {mensajeError}
                                </div>
                            )}
                            {mensajeExito && (
                                <div className="alert alert-success alert-dismissible fade show" role="alert">
                                    <strong>¡Éxito! </strong> {mensajeExito}
                                </div>
                            )}

                            {/* Formulario de carga */}
                            <form onSubmit={this.handleSubmit}>
                                <div className="form-group mb-3">
                                    <label className="font-weight-bold small">
                                        Nuevo Archivo de Certificado (.pfx / .p12): <span className="text-danger">*</span>
                                    </label>
                                    <div className="custom-file">
                                        <input
                                            type="file"
                                            className="custom-file-input"
                                            id="pfxFileInput"
                                            accept=".pfx,.p12"
                                            onChange={this.handleFileChange}
                                            disabled={isSaving}
                                        />
                                        <label className="custom-file-label" htmlFor="pfxFileInput">
                                            {nombreArchivo || 'Seleccionar archivo .pfx o .p12...'}
                                        </label>
                                    </div>
                                    <small className="form-text text-muted">
                                        El archivo será validado criptográficamente en memoria y se extraerá el NIT, titular, emisor y fechas.
                                    </small>
                                </div>

                                <div className="form-group mb-3">
                                    <label className="font-weight-bold small">
                                        Contraseña del Certificado: <span className="text-danger">*</span>
                                    </label>
                                    <div className="input-group">
                                        <input
                                            type={mostrarClave ? 'text' : 'password'}
                                            className="form-control"
                                            placeholder="Ingresa la contraseña del archivo .pfx"
                                            value={contrasenia}
                                            onChange={(e) => this.setState({ contrasenia: e.target.value })}
                                            disabled={isSaving}
                                        />
                                        <div className="input-group-append">
                                            <button
                                                type="button"
                                                className="btn btn-outline-secondary"
                                                onClick={this.toggleMostrarClave}
                                                tabIndex="-1"
                                            >
                                                {mostrarClave ? 'Ocultar' : 'Mostrar'}
                                            </button>
                                        </div>
                                    </div>
                                    <small className="form-text text-muted">
                                        La contraseña se almacena de forma segura bajo cifrado simétrico AES-256 en la base de datos.
                                    </small>
                                </div>

                                <div className="modal-footer px-0 pb-0 mt-4 border-top">
                                    <button
                                        type="button"
                                        className="btn btn-secondary mr-2"
                                        onClick={this.close}
                                        disabled={isSaving}
                                    >
                                        Cerrar
                                    </button>
                                    <button
                                        type="submit"
                                        className="btn btn-success font-weight-bold"
                                        disabled={isSaving}
                                    >
                                        {isSaving ? (
                                            <span>
                                                <span className="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
                                                Validando y guardando...
                                            </span>
                                        ) : (
                                            <span>
                                                <FontAwesomeIcon icon="key" className="mr-2" />
                                                Validar y Cargar Certificado
                                            </span>
                                        )}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default ModalCertificado;
